import { trustStats } from '@/mocks/categories';

export default function StatsSection() {
  return (
    <section id="about" className="py-16 md:py-20 px-6 md:px-10 bg-background-100">
      <div className="max-w-7xl mx-auto">
        <div className="flex flex-col lg:flex-row lg:items-start lg:gap-20">
          <div className="lg:w-1/2 mb-10 lg:mb-0">
            <span className="inline-block px-3 py-1 rounded-full bg-primary-100 text-primary-700 text-xs font-semibold mb-4">
              Why Choose Us
            </span>
            <h2 className="font-heading font-bold text-3xl md:text-4xl text-foreground-950 mb-6">
              What Is the AllChinaBuy Spreadsheet?
            </h2>
            <div className="space-y-4 text-foreground-600 leading-relaxed text-base">
              <p>
                The <strong>AllChinaBuy Spreadsheet</strong> is a carefully curated product database designed to help international buyers discover trusted sellers, compare thousands of products, and shop more efficiently through the AllChinaBuy platform.
              </p>
              <p>
                Unlike browsing randomly through agent platforms, our spreadsheet organizes verified sellers by category — giving you instant access to the best sources for shoes, clothing, bags, accessories, and Yupoo sellers. Each entry is checked for reliability before being added.
              </p>
              <p>
                Whether you are a first-time buyer or an experienced shopper, the AllChinaBuy Spreadsheet saves you hours of research and helps you avoid unreliable sellers. Combined with our safety guides and QC tips, you get a complete buying toolkit in one place.
              </p>
            </div>
          </div>

          <div className="lg:w-1/2">
            <div className="grid grid-cols-2 gap-4 md:gap-6">
              {trustStats.map((stat) => (
                <div key={stat.label} className="p-6 md:p-8 rounded-xl bg-background-50 border border-background-200 text-center">
                  <div className="font-heading font-bold text-3xl md:text-4xl lg:text-5xl text-foreground-950 mb-2">
                    {stat.value}
                  </div>
                  <div className="text-sm text-foreground-500 font-medium">
                    {stat.label}
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}